import {
   CurrentHealthcareProviderDashboardModuleConfigurationQuery,
   DashboardModuleConfiguration,
} from '@dreryk/egabinet-dashboard-frontend-api';

import { useCqrsFind } from '@dreryk/command-query-react-common';
import { MainMenu, PsychiatricIcon } from '@dreryk/react-components';

import { appTranslationKeys } from '../../translations';

import { currentHealthcareProviderModuleIndicatorVisitor } from './CurrentHealthcareProviderMainMenuIndicatorItem.utils';

export const CurrentHealthcareProviderMainMenuIndicatorItem = (): JSX.Element | null => {
   const { data: dashboardModuleConfiguration } = useCqrsFind<DashboardModuleConfiguration>(
      () => new CurrentHealthcareProviderDashboardModuleConfigurationQuery()
   );

   return currentHealthcareProviderModuleIndicatorVisitor(dashboardModuleConfiguration)({
      visitNeurologicalModule: () => (
         <MainMenu.IndicatorItem
            icon={<PsychiatricIcon />}
            testId={'neurological'}
            label={appTranslationKeys.mainMenu.moduleIndicators.neurological}
         />
      ),
      visitPsychiatricModule: () => (
         <MainMenu.IndicatorItem
            icon={<PsychiatricIcon />}
            testId={'psychiatric'}
            label={appTranslationKeys.mainMenu.moduleIndicators.psychiatric}
         />
      ),
   });
};
